
<template  minapp='mpx' xlang='wxml'>
  <controllable-drawer-bottom
    title="{{title}}"
    show="{{show}}"
    bind:close="closeOperateDrawer"
    customStyle="{{{height: '486px'}}}"
  >
    <Tab
      wx:if="{{isTransfer}}"
      wx:style="marginTop: 24px"
      tabKey="{{currentSegment}}"
      tabList="{{tabList}}"
      bind:settabkey="setCurrentSegment"
    />
    <view wx:if="{{segmentList[currentSegment]}}" class="order-info-container">
      <block wx:if="{{hasSegmentOperate(segmentList[currentSegment])}}"
        ><view
          class="order-info"
          wx:for="{{segmentList[currentSegment]}}"
          wx:key="index"
          wx:for-item="order"
          wx:if="{{hasTicketOperate(order)}}"
        >
          <view class="order-info-header">
            <view class="train-code">{{ order.train_code }}</view>
            <view class="train-station">
              <text>{{ order.from_station_name }}</text>
              <image
                class="train-station-icon"
                src="https://ut-static.udache.com/webx/sfc/X9HWVKNYaAb2Zu8ZlpcY4.png"
              />
              <text>{{ order.to_station_name }}</text>
            </view>
            <view class="train-date">
              {{ formateDate(order) }}
            </view>
          </view>
          <view
            class="ticket-info"
            wx:for="{{order.tickets_info}}"
            wx:if="{{item.showCheckBox || item.warnText}}"
            catchtap="clickCheckBox(item)"
          >
            <view class="ticket-info-content">
              <view class="ticket-info-content-top">
                <view class="passenger-name" wx:class="{{{normal: item.showCheckBox}}}">
                  {{ item.passenger_name }}
                </view>
                <view class="ticket-type">{{ getPassengerType(item.ticket_type) }}</view>
                <view class="ticket-seat" wx:class="{{{normal: item.showCheckBox}}}">
                  {{ item.seat_type }}
                </view>
                <view class="ticket-seat" wx:class="{{{normal: item.showCheckBox}}}">
                  {{ getPrice(+item.ticket_price) }}
                </view>
              </view>
              <view class="ticket-info-content-bottom">
                <view class="passenger-id-type">{{ item.passenger_id_type_name }}</view>
                <view class="passenger-id-no">{{ item.passenger_id_no }}</view>
              </view>
            </view>
            <view class="ticket-info-operate">
              <text wx:if="{{item.warnText}}">{{ item.warnText }}</text>
              <Checkbox
                ref="checkbox{{item.ticket_id}}"
                wx:elif="{{item.showCheckBox}}"
                disabled="{{currentOrder && order.order_id !== currentOrder}}"
                checkboxKey="{{item.ticket_id}}"
                wx:model="{{currentTikcet}}"
                wx:model-prop="checkedProp"
                bind:checkedChange="checkedChange"
                bind:disableClick="disableClick"
              />
            </view>
          </view> </view
      ></block>
      <view wx:else class="default-status">
        <image
          class="default-status-icon"
          src="https://ut-static.udache.com/webx/sfc/QKgKAHz74IY325JSG2_VF.png"
        />
        <view class="default-status-text">{{defaultText}}</view>
      </view>
    </view>

    <view class="footer">
      <view class="operate-button" wx:class="{{!hasChecked && 'disabled'}}" bindtap="operate">
        {{ buttonText }}
      </view>
    </view>
  </controllable-drawer-bottom>
</template>

<script>
    import { createComponent, mpx } from '@didi/es-mpx-creator'
    import { DeadLineList } from '@/utils/constants'
    import { getFinalPrice } from '@/utils/money'
    import { isFastDoubleClick } from '@/utils/double-click'
    import { formatDate, parseDate } from '@/utils/baseDate'
    import { OrderStatus, TicketStatus } from '@/common/enum'
    import { compareNow, showBtns } from '@/common/order'
    import store from '@/store'
    import dayjs from 'dayjs'
    import { selectedOverTipsConfig } from '@/config/content/index'

    createComponent({
      props: {
        show: {
          type: Boolean,
          value: false
        },
        uionType: {
          type: Number,
          value: 0
        },
        operateType: {
          type: String,
          value: 'change'
        },
        initTicket: {
          type: String,
          value: ''
        },
        initSegment: {
          type: Number,
          value: 0
        }
      },
      watch: {
        show: {
          handler(newVal, oldVal) {
            if (newVal && !oldVal) {
                this.initTicket && this.currentTikcet.push(this.initTicket)
                this.currentSegment = this.initSegment
            }
          }
        }
      },
      computed: {
        ...store.mapState({
          orderList: 'order.order_list',
          baseInfo: 'order.base_info'
        }),
        defaultText() {
          return this.operateType === 'change' ? '暂无可改车票' : '暂无可退车票'
        },
        title() {
          return this.operateType === 'change' ? '改签' : '退票'
        },
        buttonText() {
          return this.operateType === 'change' ? '去改签' : '去退票'
        },
        hasChecked() {
          return this.currentTikcet?.length
        },
        isTransfer() {
          return !!this.baseInfo.union_journey
        },
        segmentList() {
          if (!Array.isArray(this.orderList)) return []
          if (!this.isTransfer) {
            const proccessingOrderList = this.orderList?.map((order) => {
              if (!order || !order.tickets_info) return
              const tickets_info = order.tickets_info.map((item) => {
                const showCheckBox = this.showCheckBox(item)
                const warnText = this.getWarnText(item)
                return { ...item, showCheckBox, warnText }
              })
              return { ...order, tickets_info }
            })
            return [proccessingOrderList]
          }
          const _segmentList = []
          this.orderList?.forEach((order) => {
            if (!order || !order.tickets_info) return
            const tickets_info = order.tickets_info.map((item) => {
              const showCheckBox = this.showCheckBox(item)
              const warnText = this.getWarnText(item)
              return { ...item, showCheckBox, warnText }
            })
            const ticket = order.tickets_info[0]
            const index = ticket.union_segment_index - 1
            if (!_segmentList[index]) {
              _segmentList[index] = []
            }
            _segmentList[index].push({ ...order, tickets_info })
          })
          return _segmentList
        },
        currentOrder() {
          let _currentOrder
          this.orderList?.forEach((order) => {
            order.tickets_info.forEach((ticket) => {
              if (this.currentTikcet?.includes(ticket.ticket_id)) {
                _currentOrder = order.order_id
              }
            })
          })
          return _currentOrder
        },
        allTickets() {
          const allTickets = {}
          this.orderList?.forEach(({ tickets_info }) => {
            tickets_info?.forEach(({ ticket_id, start_time }) => {
              allTickets[ticket_id] = {
                start_time: parseDate(start_time).getTime()
              }
            })
          })
          return allTickets
        }
      },
      data: {
        tabList: [
          {
            label: '第1程',
            value: 0
          },
          {
            label: '第2程',
            value: 1
          }
        ],
        checked: false,
        currentSegment: 0,
        currentTikcet: []
      },
      methods: {
        formateDate(order) {
          const day = dayjs(order.start_time).format('M月D日')
          const arriveDay = dayjs(order.arrive_time).format('M月D日')
          const startHour = dayjs(order.start_time).format('HH:mm')
          const arriveHour = dayjs(order.arrive_time).format('HH:mm')
          return arriveDay !== day
            ? `${day} ${startHour} - ${arriveDay} ${arriveHour}`
            : `${day} ${startHour}-${arriveHour}`
        },
        setCurrentSegment(e) {
          this.currentTikcet = []
          this.currentSegment = e?.detail || 0
        },
        getPrice(price) {
          return `¥${getFinalPrice(price ?? 0)}`
        },
        closeOperateDrawer() {
          this.currentTikcet = []
          this.currentSegment = 0
          this.triggerEvent('close')
        },
        getPassengerType(type) {
          const TICKET_TYPE = {
            1: '成人票',
            2: '儿童票',
            3: '学生票',
            4: '残军票'
          }
          return TICKET_TYPE[type] || ''
        },
        operate() {
          if (!this.hasChecked || isFastDoubleClick()) return
          let orderParams,
            ticketParams = []
          this.orderList?.forEach((order) => {
            order.tickets_info.forEach((ticket) => {
              if (this.currentTikcet?.includes(ticket.ticket_id)) {
                orderParams = order
                ticketParams.push(ticket)
              }
            })
          })
          this.triggerEvent('operateTicket', {
            order: orderParams,
            ticket: ticketParams,
            type: this.operateType
          })
          this.closeOperateDrawer()
        },
        getWarnText(item) {
          let _warnText = ''
          if (this.operateType === 'change') {
            const { pre_ticket_id } = item
            pre_ticket_id && (_warnText = '仅支持改签1次')
          } else {
            if (item.status === 10 || item.status_name === '退票中') _warnText = '退票中'
          }
          return _warnText
        },
        checkedChange(data) {
          const value = data?.detail?.value || ''
          if (this.currentTikcet.includes(value)) {
            this.currentTikcet = this.currentTikcet.filter((item) => item !== value)
          } else {
            let type= this.operateType === 'change'? 'trainChange': 'trainRefund'
            let selectedOverTips = selectedOverTipsConfig[type]
            if(this.currentTikcet.length === selectedOverTips.maxNumber){
              let tips = selectedOverTips.overTips
              return mpx.showToast({
                title: tips, //提示的内容,
                icon: 'none' //图标,
              })
            }else{
              this.currentTikcet.push(value)
            }
          }
        },
        showCheckBox(item) {
          if (this.baseInfo.order_type === 1) return false
          if (this.operateType === 'change') {
            const { status, pre_ticket_id } = item || {}
            const show = showBtns(item)
            // 已出票 & 未改签
            return status === TicketStatus.ISSUED && !pre_ticket_id && show
          } else {
            const { status, start_time, pre_ticket_id, create_time } = item || {}
            const specificTime = dayjs(start_time).add(1, 'hour');
            const isTimeout = specificTime.isBefore(dayjs()) // 是否超出发车时间一小时 12.26改动

            let isChangeAfterGo = false // 是否是在发车后改签的
            if (pre_ticket_id && create_time) {
              const pre_ticket_start_time = this.allTickets[pre_ticket_id]?.start_time // 原票发车时间
              isChangeAfterGo = parseDate(create_time).getTime() >= pre_ticket_start_time
            }
            // (已出票 | 线下改签) 且 不超时 且 不是在发车后改签的
            const show = showBtns(item)
            return (
              [TicketStatus.ISSUED, TicketStatus.OFFLINE_REISSUE].includes(status) &&
              !isTimeout &&
              !isChangeAfterGo &&
              show
            )
          }
        },
        hasTicketOperate(order) {
          return (
            order && order.tickets_info?.some((item) => item && (item.showCheckBox || item.warnText))
          )
        },
        hasSegmentOperate(segment) {
          return (
            Array.isArray(segment) &&
            segment.some((order) => {
              return order && this.hasTicketOperate(order)
            })
          )
        },
        clickCheckBox(ticket) {
          if (!ticket.showCheckBox) return
          const name = `checkbox${ticket.ticket_id}`
          const ref = this.$refs[name]
          ref?.[0] && ref[0].toggleCheck()
        },
        disableClick() {
          mpx.showToast({
            title: '不可操作非同车次车票', //提示的内容,
            icon: 'error', //图标,
            duration: 2000, //延迟时间,
            mask: true, //显示透明蒙层，防止触摸穿透,
          });
        }
      }
    })
</script>

<style lang='stylus' scoped>
  .order-info-container
    flex 1
    margin-top 15px
    padding 0 16px
    display flex
    flex-direction column
    overflow auto
    .order-info
      display flex
      flex-direction column
      margin-bottom 14px
      &-header
        display flex
        align-items center
        flex-wrap wrap
        margin-bottom 12px
        .train-code
          font-family PingFangSC-Medium
          font-size 15px
          font-weight 500
          line-height 15px
          color #222
          margin-right 4px
        .train-station
          display flex
          font-family PingFangSC-Medium
          font-size 15px
          font-weight 500
          line-height 15px
          color #222
          align-items center
          margin-right 8px
          &-icon
            height 4px
            width 14px
            margin 0 4px
        .train-date
          font-size 13px
          font-weight 400
          font-family PingFangSC-Regular
          line-height 13px
          color #666
      .ticket-info
        display flex
        justify-content space-between
        align-items center
        padding 20px 16px
        border-radius 10px
        background #F6F9FD
        margin-bottom 10px
        &-content
          display flex
          flex-direction column
          &-top
            display flex
            align-items center
            color #999
            .passenger-name
              font-family PingFangSC-Medium
              font-size 15px
              font-weight 500
              line-height 15px
              &.normal
                color #222
            .ticket-type
              position relative
              padding 2px
              margin-left 5.5px
              border-radius 3px
              font-size 10px
              font-weight 400
              line-height 10px
              text-align center
              color #999
              &::after
                position absolute
                content ''
                width 200%
                height 200%
                box-sizing border-box
                border 1px solid #ccc
                transform-origin 0 0
                transform scale(0.5)
                border-radius 6px
                top 0
                left 0
            .ticket-seat, .ticket-price
              font-size 13px
              font-family PingFangSC-Regular
              font-weight 400
              line-height 13px
              margin-left 6px
              &.normal
                color #666
            .ticket-price
              margin-left 1px
          &-bottom
            display flex
            font-size 12px
            font-weight 400
            line-height 12px
            color #999999
            margin-top 10px
            .passenger-id-no
              margin-left 4px
              font-family PingFangSC-Regular
        &-operate
          font-size 12px
          font-weight 400
          line-height 12px
          color #999
    .default-status
      display flex
      flex-direction column
      justify-content center
      align-items center
      margin-top 48px
      &-icon
        height 100px
        width 100px
        margin-bottom 16px
      &-text
        font-family PingFangSC-Regular
        font-size 13px
        font-weight normal
        line-height 13px
        color #999
  .footer
    margin 0 20px 44px 20px
    .operate-button
      background #FF6400
      width 100%
      padding 17px 0
      font-family PingFangSC-Semibold
      font-size 16px
      font-weight 600
      line-height 16px
      text-align center
      color #fff
      border-radius 10px
      &.disabled
        opacity 0.3
</style>

  
<script name='json'>
    module.exports = {
      component: true,
      usingComponents: {
        'controllable-drawer-bottom': '@/components/controllable-drawer-buttom',
        Tab: '@/components/tab',
        Checkbox: './checkbox'
      }
    }
</script>